import { createFileRoute } from '@tanstack/react-router';
import { TenantGoogleAdsSettingsForm } from '@/components/tenants/TenantGoogleAdsSettingsForm';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/google-ads/placements')({
  component: GoogleAdsPlacementsRoute,
});

function GoogleAdsPlacementsRoute() {
  const { tenantCode } = Route.useParams();
  return <TenantGoogleAdsSettingsForm tenantCode={tenantCode} />;
}
